import { Component, ElementRef, input, viewChild, ViewChild } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  selector: 'qr-component',
  imports: [QRCodeComponent],
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
})
export class QrCodeComponent {

  // views
  qrcode = viewChild.required<QRCodeComponent>('qrcode')
  fullCanvas = viewChild.required<ElementRef<HTMLCanvasElement>>('fullCanvas')
  displayCanvas = viewChild.required<ElementRef<HTMLCanvasElement>>('displayCanvas')

  // inputs
  qrdata = input.required<string>();
  name = input.required<string>();
  email = input.required<string>();
  withPreview = input<boolean>(false)

  templateImage = new Image();
  templateLoaded = false;

  ngAfterViewInit() {
    this.loadTemplate();
  }

  loadTemplate() {
    this.templateImage.src = 'assets/images/common/qr-template.png';
    this.templateImage.onload = () => {
      this.templateLoaded = true;
      setTimeout(() => {
        this.updateCanvas();
      }, 200);
    };
  }

  updateCanvas() {
    if (!this.templateLoaded) return;

    const qrCanvas =
      this.qrcode()?.qrcElement?.nativeElement?.querySelector('canvas');
    if (!qrCanvas) {
      setTimeout(() => this.updateCanvas(), 100);
      return;
    }

    this.createFullSizeCanvas(qrCanvas);
    this.createDisplayCanvas();
  }

  createFullSizeCanvas(qrCanvas: HTMLCanvasElement) {
    const canvas = this.fullCanvas().nativeElement;
    const ctx = canvas.getContext('2d')!;

    // fix sizes
    canvas.width = 402;
    canvas.height = 874;

    // draw the template
    ctx.drawImage(this.templateImage, 0, 0, 402, 874);

    // canter the qr
    const qrSize = 260;
    const qrX = (402 - qrSize) / 2;
    const qrY = 275;

    ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);

    // draw details
    ctx.fillStyle = '#000000';
    ctx.font = 'bold 20px Quicksand';
    ctx.textAlign = 'center';
    ctx.fillText(this.name(), 201, 580);

    ctx.font = '14px Quicksand';
    ctx.fillText(this.email(), 201, 600);
  }

  createDisplayCanvas() {
    const fullCanvas = this.fullCanvas().nativeElement;
    const displayCanvas = this.displayCanvas().nativeElement;
    const ctx = displayCanvas.getContext('2d')!;

    const scale = 350 / 402; // manual scaling
    displayCanvas.width = 350;
    displayCanvas.height = 874 * scale;

    ctx.drawImage(fullCanvas, 0, 0, displayCanvas.width, displayCanvas.height);
  }

  downloadQRCode() {
    const canvas = this.fullCanvas().nativeElement;
    const url = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.download = `qrcode-${this.name().replace(/\s+/g, '-')}.png`;
    link.href = url;
    link.click();
  }
}
